module.exports = __webpack_public_path__ + "img/19-lajiao.3e5c0228.png";